import React from 'react';
import Icon from '../Icon/Icon';

interface AccordianProps {
  heading: string;
  isOpen: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const Accordion = ({ heading, isOpen, onClick, children }: AccordianProps): JSX.Element => {
  return (
    <div className="mb-5">
      <button
        data-testid="accordian-wrapper"
        className="w-full text-on-grey-subtle flex justify-between items-center d:justify-center"
        onClick={onClick}
      >
        <p className="text-sm">{heading}</p>
        <Icon
          className={isOpen ? 'rotate-180' : 'rotate-0'}
          width={24}
          fill="#D92D20"
          name="down"
        />
      </button>
      {isOpen ? <>{children}</> : ''}
    </div>
  );
};

export default Accordion;
